var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#D2E2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34443 5.13509C2.44495 5.0346 2.58126 4.97815 2.72339 4.97815C2.86552 4.97815 3.00182 5.0346 3.10234 5.13509L4.99764 7.03039L8.78717 3.24032C8.83693 3.19052 8.89602 3.15101 8.96105 3.12405C9.02609 3.09708 9.0958 3.08319 9.1662 3.08316C9.2366 3.08314 9.30632 3.09698 9.37138 3.1239C9.43643 3.15082 9.49554 3.19029 9.54534 3.24005C9.59514 3.28982 9.63465 3.3489 9.66162 3.41394C9.68858 3.47897 9.70248 3.54868 9.7025 3.61908C9.70253 3.68949 9.68868 3.75921 9.66176 3.82426C9.63484 3.88931 9.59538 3.94843 9.54561 3.99823L4.99764 8.5462L2.34443 5.89299C2.24395 5.79248 2.1875 5.65617 2.1875 5.51404C2.1875 5.37191 2.24395 5.2356 2.34443 5.13509Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCheck);
export default __webpack_public_path__ + "static/media/selectedCheck.f72be37f4400d721517db3f79517317c.svg";
export { ForwardRef as ReactComponent };